export default __webpack_public_path__ + "static/media/quickstart-step-5.925e2d3e.jpg";